import { PrimaryButton, SecondaryButton } from '@library/components/buttons';

export interface FileUploaderModalButtonsProps {
  disabled?: boolean;
  onCancel: () => void;
  onFileUpload: () => void;
}

export const FileUploaderModalButtons = ({
  disabled = false,
  onCancel,
  onFileUpload
}: FileUploaderModalButtonsProps) => {
  return (
    <div className="flex items-center justify-end gap-4">
      <SecondaryButton
        className="h-10"
        title="FileUploaderCancelButton"
        handleOnClick={onCancel}
        testId="file-uploader-modal-secondary-button"
      >
        Cancel
      </SecondaryButton>
      <PrimaryButton
        className="outline-hidden flex h-10 w-16 items-center justify-center rounded-md border-none"
        disabled={disabled}
        title="FileUploaderSaveButton"
        handleOnClick={onFileUpload}
      >
        Save
      </PrimaryButton>
    </div>
  );
};
